import React, { useEffect, useRef, useLayoutEffect, useState } from "react";
import logo from "../../assets/logo/logo.jpg";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Collapse, Dropdown } from "flowbite";
import retail from "../../assets/products/retail.png"
import billing from "../../assets/products/bill.png"
import crm from "../../assets/products/crm.png"
import expense from "../../assets/products/expense.png"
import payroll from "../../assets/products/payroll.png"


const Navbar = () => {
  const target = useRef(null);
  const trigger = useRef(null);
  const teamButton = useRef(null);
  const teamDropdown = useRef(null);
  const otherButton = useRef(null);
  const otherDropdown = useRef(null);
  const navigate1 = useNavigate();
  const location = useLocation();
  // const dispatch = useDispatch();
  const [bool, setbool] = useState(false);
  const navigate = useNavigate();
  const boolfunc = () => {
    setbool(true);
    mobile();
  };

  //Mobile Navbar func
  const mobile = () => {
    const hammenu = target.current;
    const nav = trigger.current;

    const navoptions = {
      onCollapse: () => { },
      onExpand: () => { },
      onToggle: () => { },
    };
    const mobnav = new Collapse(hammenu, nav, navoptions);
    mobnav.expand();
    mobnav.collapse();

    if (bool == true) {
      mobnav.collapse();
    }
  };

  //Team Dropdown function
  const teamDrop = () => {
    const team = teamButton.current;
    const teamdown = teamDropdown.current;

    const teamoptions = {
      placement: "bottom",
      triggerType: "click",
      offsetSkidding: 0,
      offsetDistance: 10,
      delay: 300,
      onHide: () => { },
      onShow: () => { },
      onToggle: () => { },
    };
    const dropdownTeam = new Dropdown(teamdown, team, teamoptions);
    dropdownTeam.show();

    dropdownTeam.hide();
  };


  //Other Dropdown function
  const otherDrop = () => {
    const other = otherButton.current;
    const otherdown = otherDropdown.current;

    const otheroptions = {
      placement: "bottom",
      triggerType: "click",
      offsetSkidding: 0,
      offsetDistance: 10,
      delay: 300,
      onHide: () => { },
      onShow: () => { },
      onToggle: () => { },
    };
    const dropdownother = new Dropdown(otherdown, other, otheroptions);
    dropdownother.show();

    dropdownother.hide();
  };
  useEffect(() => {
    mobile();
    teamDrop();
    otherDrop();
  }, []);


  return (
    // <nav className="bg-white dark:bg-white-900 fixed  w-full z-20 p-4 top-0 left-0 border-b border-gray-200 dark:border-gray-600  ">
    //   <div className=" flex flex-wrap items-center justify-between mx-auto p-2 overflow-visible">
    //     <a
    //       onClick={() =>
    //         navigate1({
    //           pathname: `${process.env.PUBLIC_URL}/`,
    //         })
    //       }
    //       className="flex items-center cursor-pointer  "
    //     >
    //       <img src={logo} className="h-8 mr-3" alt="logo" />
    //       <span className="self-center text-2xl font-bold font-mfont dark:text-white">
    //         Making Minds Technologies
    //       </span>
    //     </a>
    //     <div className="flex md:order-2 overflow-hidden">
    //       <button
    //         data-collapse-toggle="navbar-sticky"
    //         id="hammenu"
    //         ref={trigger}
    //         type="button"
    //         className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 overflow-visible"
    //         aria-controls="navbar-sticky"
    //         aria-expanded="false"
    //       >
    //         <span className="sr-only">Open main menu</span>
    //         <svg
    //           className="w-6 h-6"
    //           aria-hidden="true"
    //           fill="currentColor"
    //           viewBox="0 0 20 20"
    //           xmlns="http://www.w3.org/2000/svg"
    //         >
    //           <path
    //             fillRule="evenodd"
    //             d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
    //             clipRule="evenodd"
    //           ></path>
    //         </svg>
    //       </button>
    //     </div>

    //     <div
    //       className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
    //       id="navbar-sticky"
    //       aria-current="page"
    //       ref={target}
    //     >
    //       <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium   md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700 ">
    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/` || location.pathname === `${process.env.PUBLIC_URL}/home` ? (
    //             <span style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc()
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/`
    //                 })
    //               }
    //               }
    //               className="block px-4 py-2 pl-3 pr-4 uppercase  rounded
    //               xl:inline xl:bg-mcolor   text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-4 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //             >
    //               Home
    //             </span>
    //           ) : (
    //             <span style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc()
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/`
    //                 })
    //               }
    //               }
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white uppercase  text-black 
    //                xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-4 xl:hover:border-transparent xl:rounded font-mfont"
    //             >
    //               Home
    //             </span>
    //           )}
    //         </li>

    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/about` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/about`,
    //                 });
    //               }}
    //             >
    //               About
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white uppercase  text-black 
    //                xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/about`,
    //                 });
    //               }}
    //             >
    //               About
    //             </span>
    //           )}
    //         </li>

    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/service` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/service`,
    //                 });
    //               }}
    //             >
    //               Services
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white uppercase  text-black 
    //                xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/service`,
    //                 });
    //               }}
    //             >
    //               Services
    //             </span>
    //           )}
    //         </li>




    //         <li>
    //           <button
    //             ref={teamButton}
    //             id="dropdownNavbarLink"
    //             data-dropdown-toggle="dropdownNavbar1"
    //             data-dropdown-trigger="hover"
    //             className="flex items-center uppercase justify-between w-full py-2 pl-3 pr-4block  pr-4 text-gray-900 rounded
    //            hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-900 md:p-0
    //             md:dark:hover:text-red-500 dark:text-white dark:hover:bg-mcolor
    //              dark:hover:text-white md:dark:hover:bg-transparent dark:border-blue-900"
    //           >
    //             Services{" "}
    //             <svg
    //               className="w-5 h-5 ml-1"
    //               aria-hidden="true"
    //               fill="currentColor"
    //               viewBox="0 0 20 20"
    //               xmlns="http://www.w3.org/2000/svg"
    //             >
    //               <path
    //                 fillRule="evenodd"
    //                 d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    //                 clipRule="evenodd"
    //               ></path>
    //             </svg>
    //           </button>
    //           <div
    //             ref={teamDropdown}
    //             id="dropdownNavbar1"
    //             className="z-40 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
    //           >
    //             <ul
    //               className="py-2 text-sm text-black dark:text-gray-400"
    //               aria-labelledby="dropdownLargeButton"
    //             >
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/websitedevelopment`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Website Development
    //                 </span>
    //               </li>
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/websitemaintaince`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Website Maintaince
    //                 </span>
    //               </li>
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/posterdesigns`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Poster Designs{" "}
    //                 </span>
    //               </li>
    //             </ul>
    //           </div>
    //         </li>

    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/careers` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/careers`,
    //                 });
    //               }}
    //             >
    //               Careers
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white uppercase  text-black 
    //                xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded font-mfont"
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/careers`,
    //                 });
    //               }}
    //             >
    //               Careers
    //             </span>
    //           )}
    //         </li>

    //         <li>
    //           <button
    //             ref={otherButton}
    //             id="others"
    //             data-dropdown-toggle="dropdownNavbar2"
    //             data-dropdown-trigger="hover"
    //             className="flex items-center uppercase justify-between w-full py-2 pl-3 pr-4block  pr-4 text-gray-900 rounded
    //             hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-900 md:p-0
    //              md:dark:hover:text-red-500 dark:text-white dark:hover:bg-mcolor
    //               dark:hover:text-white md:dark:hover:bg-transparent dark:border-blue-900"
    //           >
    //             Package{" "}
    //             <svg
    //               className="w-5 h-5 ml-1"
    //               aria-hidden="true"
    //               fill="currentColor"
    //               viewBox="0 0 20 20"
    //               xmlns="http://www.w3.org/2000/svg"
    //             >
    //               <path
    //                 fillRule="evenodd"
    //                 d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
    //                 clipRule="evenodd"
    //               ></path>
    //             </svg>
    //           </button>
    //           <div
    //             ref={otherDropdown}
    //             id="dropdownNavbar2"
    //             className="z-40 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600"
    //           >
    //             <ul
    //               className="py-2 text-sm text-gray-700 dark:text-gray-400"
    //               aria-labelledby="dropdownLargeButton"
    //             >
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/pricing`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Website Package{" "}
    //                 </span>
    //               </li>
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/websitemaintaincepackage`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Website Maintaince{" "}
    //                 </span>
    //               </li>
    //               <li>
    //                 <span style={{ cursor: "pointer" }}
    //                   onClick={() => {
    //                     boolfunc()
    //                     navigate({
    //                       pathname: `${process.env.PUBLIC_URL}/postermaking`
    //                     })
    //                   }
    //                   }
    //                   className="block px-4 py-2 font-semibold  hover:bg-mcolor hover:text-white dark:hover:bg-gray-600 dark:hover:text-white"
    //                 >
    //                   Poster Making
    //                 </span>
    //               </li>

    //             </ul>
    //           </div>
    //         </li>

    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/pricing` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/pricing`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded"
    //             >
    //               Pricing
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/pricing`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white uppercase   text-black 
    //                xl:hover:bg-white  xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded"
    //             >
    //               Pricing
    //             </span>
    //           )}
    //         </li>


    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/makingminds/products` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/makingminds/products`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //             >
    //               Products
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/makingminds/products`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white   text-black 
    //                xl:hover:bg-white uppercase xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded font-mfont"
    //             >
    //               Products
    //             </span>
    //           )}
    //         </li>

    //         <li>
    //           {location.pathname === `${process.env.PUBLIC_URL}/contact` ? (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/contact`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-mcolor uppercase  text-black  xl:hover:bg-mcolor
    //                 xl:mb-8 xl:font-semibold xl:text-white xl:py-2 xl:px-2 xl:hover:border-transparent 
    //                 xl:rounded font-mfont"
    //             >
    //               Contact
    //             </span>
    //           ) : (
    //             <span
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 boolfunc();
    //                 navigate1({
    //                   pathname: `${process.env.PUBLIC_URL}/contact`,
    //                 });
    //               }}
    //               className="block px-4 py-2 pl-3 pr-4  rounded
    //               xl:inline xl:bg-white   text-black 
    //                xl:hover:bg-white uppercase xl:mb-8 xl:font-semibold xl:text-black xl:py-2 
    //                xl:px-2 xl:hover:border-transparent xl:rounded font-mfont"
    //             >
    //               Contact
    //             </span>
    //           )}
    //         </li>


    //       </ul>
    //     </div>
    //   </div>
    // </nav>
    <nav className="bg-white dark:bg-white-900 fixed w-full z-20 p-1.5  top-0 left-0 border-b border-gray-200 dark:border-gray-600  ">
      <div className="xl:container m-auto px-6 md:px-12">
        <div className="flex flex-wrap items-center justify-between gap-6 md:py-3 md:gap-0">
          <div className="w-full flex justify-between lg:w-auto">
            <a
              onClick={() =>
                navigate1({
                  pathname: `${process.env.PUBLIC_URL}/`,
                })
              }
              className="flex items-center cursor-pointer  "
            >
              <img src={logo} className="h-8 mr-3" alt="logo" />
              <span className="self-center lg:text-2xl text-lg text-mcolor font-bold font-mfont dark:text-white">
                Making Minds Technologies
              </span>
            </a>
            <div className="flex md:order-2 overflow-hidden">
              <button
                data-collapse-toggle="navbar-sticky"
                id="hammenu"
                ref={trigger}
                type="button"
                className="inline-flex items-center p-4 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 overflow-visible"
                aria-controls="navbar-sticky"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  fill="#000"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div
            className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
            id="navbar-sticky"
            aria-current="page"
            ref={target}
          >
            <div className="w-full space-y-2 border-primary/10 dark:border-gray-700 flex flex-col -ml-1 sm:flex-row lg:space-y-0 md:w-max ">
              <div className="text-black  font-semibold font-poppins block px-4 py-1  text-lg"   >
                <button
                  ref={otherButton}
                  id="others"
                  data-dropdown-toggle="dropdownNavbar3"
                  className="flex items-center font-mfont w-full  text-mcolor font-semibold md:p-0  "
                >
                  Products{" "}
                  <svg
                    className="w-5 h-5 ml-1"
                    aria-hidden="true"
                    fill="#000"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <div
                  ref={otherDropdown}
                  id="dropdownNavbar3"
                  className="z-40 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-[320px] dark:bg-gray-700 dark:divide-gray-600"
                >
                  <ul className="py-2 " aria-labelledby="dropdownLargeButton">
                    <p className="text-sm font-mfont font-semibold mx-4">Human Resorces</p>
                    <li>
                      <a
                        href="/makingminds/products"
                        className="flex px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        <img src={payroll} alt="retail" width="22" height="22" /> &nbsp;&nbsp; Payroll{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.expensetracker.fun/"
                        target="_blank" rel="noreferrer"
                        className="flex px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        <img src={expense} alt="retail" width="22" height="22" /> &nbsp;&nbsp; Expense{" "}
                      </a>
                    </li>
                    <hr />
                    <p className="text-sm mt-2 font-mfont font-semibold mx-4">Finance</p>
                    <li>
                      <a
                        href="https://www.makingmindsbilling.site/"
                        target="_blank" rel="noreferrer"
                        className="flex px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        <img src={billing} alt="retail" width="22" height="22" /> &nbsp;&nbsp; Billing{" "}
                      </a>
                    </li>
                    <hr />
                    <p className="text-sm mt-2 font-mfont font-semibold mx-4"> &nbsp;&nbsp;Sales</p>
                    <li>
                      <a
                        href="/makingminds/products"
                        className="flex px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        <img src={crm} alt="retail" width="22" height="22" />  &nbsp;&nbsp;CRM{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/makingminds/products"
                        className="flex px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        <img src={retail} alt="retail" width="22" height="22" /> &nbsp;&nbsp;Retail{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="text-mblack  font-semibold font-poppins block px-4 py-1 text-lg"    >
                <button
                  ref={teamButton}
                  id="others"
                  data-dropdown-toggle="dropdownNavbar2"
                  className="flex items-center font-mfont w-full  text-mcolor font-semibold md:p-0  "
                >
                  Company{" "}
                  <svg
                    className="w-5 h-5 ml-1"
                    aria-hidden="true"
                    fill="#000"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <div
                  ref={teamDropdown}
                  id="dropdownNavbar2"
                  className="z-40 hidden font-normal bg-white divide-y divide-gray-100 rounded-lg shadow w-[240px] dark:bg-gray-700 dark:divide-gray-600"
                >
                  <ul className="py-2 " aria-labelledby="dropdownLargeButton">
                    {/* <li>
                      <a
                        href="/makingminds/products"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Products{" "}
                      </a>
                    </li>
                    <hr /> */}
                    <li>
                      <a
                        href="/about"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        About us{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/makingminds/workspace"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Work Space{" "}
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="/makingminds/our-story"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Our Story{" "}
                      </a>
                    </li> */}
                    <hr />
                    <li>
                      <a
                        href="/makingminds/events"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Events{" "}
                      </a>
                    </li>
                    <hr />
                    <li>
                      <a
                        href="/makingminds/careers"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Careers{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/makingminds/training"
                        className="block px-4 py-2 mr-4 hover:text-blue-600 md:mr-6 text-black  font-semibold font-mfont text-md  "
                      >
                        Trainings{" "}
                      </a>
                    </li>

                  </ul>
                </div>
              </div>

              <>
                <div className="flex items-center space-x-2 lg:border-l rtl:space-x-reverse pl-2 px-4 py-1 ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" className="mt-0.5">
                    <rect width="24" height="24" fill="white" />
                    <circle cx="12" cy="12" r="9" stroke="#000000" strokeLinejoin="round" />
                    <path d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                    <path d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                    <path d="M3 12H21" stroke="#000000" strokeLinejoin="round" />
                    <path d="M19.5 7.5H4.5" stroke="#000000" strokeLinejoin="round" />
                    <g filter="url(#filter0_d_15_556)">
                      <path d="M19.5 16.5H4.5" stroke="#000000" strokeLinejoin="round" />
                    </g>
                    <defs>
                      <filter id="filter0_d_15_556" x="3.5" y="16" width="17" height="3" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="1" />
                        <feGaussianBlur stdDeviation="0.5" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_556" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_556" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                  <a className="text-sm font-bold text-mblack font-mfont mt-1 dark:text-mblack hover:underline">English</a>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </nav >
  );
};

export default Navbar;
